import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { formatPrice } from '@chama/utils/functions/currency';
import phoneFormatters from '@chama/utils/i18n/format-phone';
import Table from '@chama/ui-components/components/Table';
import ShopOpeningTimesStatusLabel from '@app/components/ShopOpeningTimesStatusLabel';

const propTypes = {
  dealer: PropTypes.object.isRequired,
};

const formatPhone = phoneFormatters['pt-BR'];

const renderETA = eta => {
  if (eta && eta.from && eta.to) {
    return (
      <div>
        <span>{eta.from}m</span> - <span>{eta.to}m</span>
      </div>
    );
  }

  return (
    <div>
      <span>N/A</span>
    </div>
  );
};

const renderOpeningTimes = dealer => {
  const { isOpened, willCloseAt, willOpenAt } = dealer;
  const date = isOpened ? willCloseAt : willOpenAt;
  const now = moment();
  const target = moment(date);
  const diff = Math.abs(target.dayOfYear() - now.dayOfYear());
  const isToday = diff === 0;
  const isTomorrow = diff === 1;
  const renderOpeningText = () => {
    if (isOpened) {
      return <FormattedMessage id="closes" defaultMessage="Closes" />;
    }

    return <FormattedMessage id="opens" defaultMessage="Opens" />;
  };
  const renderText = when => {
    return (
      <span>
        <span className="u__capitalize">{renderOpeningText()}</span>
        &nbsp;
        {when}
        &nbsp;
        <FormattedMessage id="time_at" defaultMessage="time_at" />
        &nbsp;
        {target.format('HH:mm')}
      </span>
    );
  };

  if (isToday) {
    return renderText(<FormattedMessage id="today" defaultMessage="today" />);
  }

  if (isTomorrow) {
    return renderText(<FormattedMessage id="tomorrow" defaultMessage="tomorrow" />);
  }

  return renderText(target.format('DD/MM'));
};

const getPhone = dealer => {
  if (dealer.phone) {
    return formatPhone(dealer.phone.replace('+55', ''), false);
  }

  return 'N/A';
};

const NearbyDealerItem = ({ dealer }) => {
  const ellipseClassName = classNames('DealersNearbyList__ellipse', {
    'DealersNearbyList__ellipse--open': dealer.isActive,
  });

  return (
    <Table.Row>
      <Table.Cell>
        <span>{dealer.name}</span>
      </Table.Cell>
      <Table.Cell>
        <span>{dealer.brand}</span>
      </Table.Cell>
      <Table.Cell>
        <span>{getPhone(dealer)}</span>
      </Table.Cell>
      <Table.Cell>
        <span>{dealer.rating}</span>
      </Table.Cell>
      <Table.Cell>
        <span>{formatPrice(dealer.price)}</span>
      </Table.Cell>
      <Table.Cell>{renderETA(dealer.eta)}</Table.Cell>
      <Table.Cell>{renderOpeningTimes(dealer)}</Table.Cell>
      <Table.Cell>
        <span>
          <ShopOpeningTimesStatusLabel status={dealer.status} />
          <span className={ellipseClassName} />
        </span>
      </Table.Cell>
    </Table.Row>
  );
};

NearbyDealerItem.propTypes = propTypes;

export default NearbyDealerItem;



// WEBPACK FOOTER //
// ./src/modules/orders/components/OrderDetailsLayout/DealersNearbyList/NearbyDealerRow.jsx